import React from 'react';
import Footer from '../components/footer';
import phoneIcon from '../assets/images/phoneIcon.svg';
import '../styling/containerStyles.css'

interface ErrorMessageProps{
    addClass?:string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = (props: ErrorMessageProps) =>{
    const { addClass } = props;
        return (
            addClass === 'app3' ?
                <div className="App">
                    <div className='home popup_logout'>
                        <div className='suc' id="cust box">
                            <div className='failure_transaction validation_failure'>
                                <h2>Your KYC has been rejected. Kindly contact the customer support on&nbsp;
                                    <div className='rightText customer_care'><a href="tel:919223192020">
                                        <img src={phoneIcon} alt='Phone Icon' className='phoneIcon' />
                                        919223192020</a></div>
                                    &nbsp;or email us at <div className='rightText customer_care'>
                                        <a href="mailto:cwcsupport@pidilite.com">cwcsupport@pidilite.com</a></div></h2>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div> 
            :
            addClass ?
            <div className="App"> 
            <div className='home popup_logout'>                
                <div className='suc' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>{'Something went wrong please try again.'}</h2>
                    </div>
                </div>
                <Footer />
            </div>
            </div>
            :
            <div className='home popup_logout'>                
                <div className='suc' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>{'Something went wrong please try again.'}</h2>
                    </div>
                </div>
                <Footer />
            </div>  
        )
    }

export default ErrorMessage;